export var getHourData = function getHourData(hour, mode) {
  var h = parseInt(hour);
  if (mode === 'am/pm') {
    var isPm = h > 12;
    var suffix = isPm ? ' pm' : ' am';
    if (isPm) {
      return {
        hourStr: ('0' + (h - 12)).slice(-2),
        suffix: suffix
      };
    }
    return {
      hourStr: hour,
      suffix: suffix
    };
  }
  return {
    hourStr: hour,
    suffix: ''
  };
};